/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import IUserMedalInfo from '../../../../interface/userMedal';
import If from '../../../components/if';
import { $window } from '../../../utils/bom';
import { classSet } from '../../../utils/dom';
import ImageUtil from '../../../utils/imageUtil';
import React, { Component } from 'react';
import UserLevelBadge, { TUserLevelSize } from '../userLevelBadge/userLevelBadge';
import UserMedalIcon from '../userMedalIcon/userMedalIcon';
import './userAvatar.scss';
import _get from 'lodash/get';

function getDefaultAvatar(): string | undefined {
    const logo_account: string | undefined = _get($window, 'pageData.enterprise_setting.logo_account') || _get($window, 'pageData.teacherInfo.enterpriseInfo.logo_account');

    return logo_account;
}

const defaultAvatar = require('./images/defaultAvatar.png');

export interface IProps {
    className: string;
    src: string;
    width?: number;
    index?: number;
    userLevelInfo?: number;
    userMedalInfo?: IUserMedalInfo;
    showUserLevel?: number;
    userMedalWidth?: 20 | 30 | 16 | 12;
    userLevelSize?: TUserLevelSize;
    href?: string;
}

interface IState {
    loadFail: boolean;
}

export default class UserAvatar extends Component<IProps, IState> {
    constructor(props: IProps, state: IState) {
        super(props, state);

        this.loadError = this.loadError.bind(this);

        this.state = {
            loadFail: false,
        };
    }

    public loadError() {
        this.setState({
            loadFail: true,
        });
    }

    public renderAvatarImage() {
        const { src, width = 40 } = this.props;
        const style = {
            width: `${width}px`,
            height: `${width}px`,
        };

        const imgSrc =
            !this.state.loadFail && src
                ? ImageUtil.appendWidth(src, width * 2)
                : getDefaultAvatar() || defaultAvatar.default || defaultAvatar;
        return (
            <div className="user-avatar-image img" style={style}>
                <img src={imgSrc} onError={this.loadError} />
            </div>
        );
    }

    public redirectToProfileHome = (href = '') => {
        if (!href) {
            return;
        }
        $window.open(href, '_blank');
    };

    public render() {
        const {
            className,
            userMedalInfo,
            showUserLevel = 0,
            userLevelInfo = 0,
            userMedalWidth = 20,
            userLevelSize,
            href = '',
        } = this.props;
        const userLevelHolderSize = userLevelSize ? ' size-' + userLevelSize : '';
        const cursor = !!href ? 'cursor' : '';
        return (
            <div
                className={classSet('user-avatar-info', className, cursor)}
                onClick={() => this.redirectToProfileHome(href)}
            >
                {this.renderAvatarImage()}
                <If condition={showUserLevel === 1 && userLevelInfo !== 0}>
                    <div className={'user-level-info-holder' + userLevelHolderSize}>
                        <UserLevelBadge userLevelInfo={userLevelInfo} userLevelSize={userLevelSize} />
                    </div>
                </If>
                <If condition={showUserLevel === 1 && !!userMedalInfo && !!userMedalInfo.medal_type}>
                    <div className="user-medal-info-holder">
                        <UserMedalIcon userMedalInfo={userMedalInfo!} userMedalWidth={userMedalWidth} />
                    </div>
                </If>
            </div>
        );
    }
}
